export default [
    {
        id: 1,
        name_ca: 'Immoble centrat en la parcel·la',
        name_en: 'Building centered on plot',
        name_es: 'Inmueble centrado en la parcela'
    },
    {
        id: 2,
        name_ca: 'Lliure',
        name_en: 'Free',
        name_es: 'Libre'
    },
    {
        id: 3,
        name_ca: 'L\'immoble ocupa la totalitat de la parcel·la',
        name_en: 'Building occupies the whole plot',
        name_es: 'El inmueble ocupa la totalidad de la parcela'
    },
    {
        id: 4,
        name_ca: 'L\'immoble deixa un pati posterior',
        name_en: 'Building with a backyard',
        name_es: 'El inmueble deja un patio posterior'
    },
    {
        id: 999,
        name_ca: 'Altra',
        name_en: 'Other',
        name_es: 'Otra'
    }
]



// WEBPACK FOOTER //
// ./src/options/plot_occupations.js